import React from 'react';
import './OwOwner.css';
import TryFreeBtn from '../../components/TryFreeBtn';

const OwOwner = () => {
  const features = [
    {
      id: 1,
      image: '/images/owner/1.png',
      title: 'Company Management',
      description: 'View and manage all your registered companies in one centralized dashboard. Keep track of company details, status, and associated restaurants with ease.'
    },
    {
      id: 2,
      image: '/images/owner/2.png',
      title: 'Add & Edit Companies',
      description: 'Create new company profiles and update existing information seamlessly. All your business entities organized and editable at your fingertips.'
    },
    {
      id: 3,
      image: '/images/owner/3.png',
      title: 'Restaurant Overview',
      description: 'Browse through all your restaurants with an intuitive list view. Quickly add new locations and manage your entire restaurant portfolio.'
    },
    {
      id: 4,
      image: '/images/owner/4.png',
      title: 'Restaurant Details Hub',
      description: 'Access comprehensive restaurant information including location, tables, menus, orders, and subscription details all in one place.'
    },
    {
      id: 5,
      image: '/images/owner/5.png',
      title: 'Edit Restaurant Info',
      description: 'Update restaurant details, operating hours, contact information, or remove locations when needed. Full control over your restaurant data.'
    },
    {
      id: 6,
      image: '/images/owner/6.png',
      title: 'Smart Location Management',
      description: 'Set your restaurant location using coordinates, interactive map pin placement, or utilize "Use Current Location" for instant setup.'
    },
    {
      id: 7,
      image: '/images/owner/7.png',
      title: 'Table Configuration',
      description: 'Manage your restaurant seating arrangements. Add, edit, view, or remove tables to match your floor plan and optimize service.'
    },
    {
      id: 8,
      image: '/images/owner/8.png',
      title: 'Menu & Category Control',
      description: 'Organize your menu by categories (drinks, starters, mains, desserts) and manage all dishes within each category. Add, edit, or remove items anytime.'
    },
    {
      id: 9,
      image: '/images/owner/9.png',
      title: 'Staff Management System',
      description: 'Oversee your entire team across all restaurants and companies. Add, edit, or remove managers, waiters, cooks, and bartenders effortlessly.'
    },
    {
      id: 10,
      image: '/images/owner/10.png',
      title: 'Profile & Settings',
      description: 'Manage personal data, access contact options, review terms and conditions, and configure your account preferences all in one place.'
    },
    {
      id: 11,
      image: '/images/owner/11.png',
      title: 'Guest Order Management',
      description: 'Fully manage all customer orders from guests dining at your tables. View new orders, accept them, prepare dishes, and coordinate with your kitchen and service staff.'
    },
    {
      id: 12,
      image: '/images/owner/12.png',
      title: 'Payment Management',
      description: 'Manage customer payments when guests request to pay through OW Client app. Process payments, handle transactions, and complete the dining experience seamlessly.'
    },
    {
      id: 13,
      image: '/images/owner/13.png',
      title: 'Order History & Status',
      description: 'Access complete order history with filters for completed and cancelled orders. Detailed insights into every transaction for better business decisions.'
    }
  ];

  return (
    <div className="ow-owner-page">
      {/* Hero Section */}
      <section
        className="owner-hero-section"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.2) 100%), url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`
        }}
      >
        <div className="owner-hero-content">
          <div className="coming-soon-badge">
            <span className="badge-icon">🚀</span>
            <span>COMING SOON</span>
          </div>
          <h1 className="owner-hero-title">OW Owner</h1>
          <p className="owner-hero-subtitle">
            The Ultimate Restaurant Management Platform
          </p>
          <p className="owner-hero-description">
            Transform the way you manage your restaurant business. From company registration
            to order fulfillment, control everything from one powerful platform.
          </p>
          <div className="owner-hero-button">
            <TryFreeBtn />
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">13+</div>
              <div className="stat-label">Powerful Features</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Control</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Access</div>
            </div>
          </div>
          <a href="#how-it-works" className="btn btn-hero">
            Discover How It Works
          </a>
        </div>
      </section>

      {/* About Section */}
      <section className="owner-about-section">
        <div className="container">
          <h2 className="section-title">Built for Restaurant Owners</h2>
          <p className="section-description">
            OW Owner is designed to give you complete control over your restaurant operations.
            Manage multiple companies, restaurants, staff, menus, and orders all from a single,
            intuitive interface. We're crafting the perfect tool to help you succeed.
          </p>
          <div className="about-features">
            <div className="about-feature">
              <div className="about-feature-icon">🏢</div>
              <h3>Company Management</h3>
              <p>Register and manage multiple business entities</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">🍴</div>
              <h3>Restaurant Control</h3>
              <p>Full oversight of all your restaurant locations</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">📋</div>
              <h3>Menu Mastery</h3>
              <p>Complete control over categories and products</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">👨‍🍳</div>
              <h3>Staff Coordination</h3>
              <p>Manage your entire team across all locations</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">🍕</div>
              <h3>Guest Order Management</h3>
              <p>Handle all customer orders from table to payment</p>
            </div>
            <div className="about-feature">
              <div className="about-feature-icon">📍</div>
              <h3>Location Tools</h3>
              <p>Interactive maps and smart location features</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="owner-how-it-works-section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            A comprehensive walkthrough of all features and capabilities
          </p>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={feature.id} className="feature-card">
                <div className="feature-number">{index + 1}</div>
                <div className="feature-image-wrapper">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="feature-image"
                  />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section
        className="owner-cta-section"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.3) 100%), url(${process.env.PUBLIC_URL}/images/horizontal_background.png)`
        }}
      >
        <div className="container">
          <div className="cta-content">
            <div className="cta-icon">⏰</div>
            <h2 className="cta-title">Be the First to Know!</h2>
            <p className="cta-description">
              We're putting the finishing touches on OW Owner. This powerful restaurant
              management platform will revolutionize how you run your business.
              Stay tuned for the launch!
            </p>
            <div className="progress-indicator">
              <div className="progress-bar">
                <div className="progress-fill"></div>
              </div>
              <p className="progress-text">In Active Development • Launching Soon</p>
            </div>
            <div className="cta-features-mini">
              <span className="mini-feature">✓ Multi-Restaurant Management</span>
              <span className="mini-feature">✓ Real-Time Guest Orders</span>
              <span className="mini-feature">✓ Complete Menu Control</span>
              <span className="mini-feature">✓ Staff Management</span>
            </div>
            <div className="owner-cta-button">
              <TryFreeBtn />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OwOwner;


